<template>
	<div class="summary">
		<div class="summary__title">{{ $t('checkout.purchase-summary') }}</div>

		<div v-for="item in products" :key="item.productId" class="summary__purchase">
			<div
				class="summary__purchase__type"
				:class="item.productType ? `summary__purchase__type--${item.productType}` : ''"
			>
				{{
					item.productType && item.productType === 'nxwallet'
						? `${$n(item.value)} NX`
						: item.productType === 'wallet'
						? $n(item.amount)
						: item.name
				}}
			</div>
			<div class="summary__purchase__amount">{{ $n(item.amount, 'currency', item.currency) }}</div>
		</div>

		<button class="summary__change-amount btn-link-blue" @click="changeAmount">
			{{ $t('checkout.change-amount') }}
			<svgIcon icon-holder-class="icon-faq" icon-id="icon-page-right-blue" />
		</button>

		<div class="summary__price">
			<div v-if="showSalesTax" class="summary__price__tax">
				<span>{{ $t('checkout.sales-tax') }}</span>
				<span>{{ $n(tax, 'currency', currency) }}</span>
			</div>
			<div class="summary__price__total">
				<span>{{ $t('checkout.total') }}</span>
				<span>{{ $n(total, 'currency', currency) }}</span>
			</div>
		</div>

		<License
			:style="{
				paddingTop: '16px',
				textAlign: 'left',
				borderTop: '2px solid rgba(255, 255, 255, 0.5)',
			}"
			@termClick="handleTermClick"
			@supportClick="handleSupportClick"
		/>
	</div>
</template>

<script>
import summaryMixin from '@/components/purchase/summary-mixin';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import config from '@/config/environment-config';
import License from '@/components/common/license.vue';

export default {
	name: 'PurchaseSummary',
	components: {
		svgIcon,
		License,
	},
	mixins: [summaryMixin],
	data() {
		return {};
	},
	methods: {
		handleTermClick() {
			this.$a2s.click('location_terms');
		},
		handleSupportClick() {
			this.$a2s.click('location_support');
		},
		changeAmount() {
			this.$a2s.click('location_change_amount');
			dataLayer.push({
				event: 'Add Balance Change Amount Click',
			});
			window.location.href = `${config[process.env.VUE_APP_ENV][environment.region].wallet}/${
				this.$i18n.locale
			}/add-balance`;
		},
	},
};
</script>

<style lang="less" scoped>
.summary {
	flex: 0 0 100%;
	max-width: 100%;
	padding: 13px 20px;
	border: 1px solid rgb(#fff, 20%);
	border-radius: 2px;
	background-color: rgba(#fff, 5%);
	margin-bottom: 5px;
	&__title,
	&__purchase {
		font-size: 18px;
		font-weight: bold;
	}
	&__title {
		color: #fff;
		padding-bottom: 16px;
		border-bottom: 2px solid rgba(#fff, 50%);
	}
	&__purchase {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		color: #fff;
		border-bottom: 1px solid rgba(#fff, 20%);
		padding-top: 10px;
		padding-bottom: 9px;
		line-height: 1.6;
		margin-bottom: 13px;
		&__type {
			display: flex;
			align-items: center;
			span {
				padding-left: 5px;
			}
			&--wallet,
			&--nxwallet {
				&:before {
					content: '';
					display: inline-block;
					width: 30px;
					height: 30px;
					background-repeat: no-repeat;
					background-size: contain;
					background-position: left center;
					margin-right: 10px;
				}
			}
			&--nxwallet {
				&:before {
					background-image: url('~@/images/nx.png');
				}
			}
			&--wallet {
				&:before {
					background-image: url('~@/images/coin.png');
				}
			}
		}
		&__amount {
			margin-left: auto;
			padding-left: 5px;
		}
	}
	&__change-amount {
		position: relative;
		padding: 6px 0 0 0;
		text-transform: uppercase;
	}
	&__price {
		margin-left: auto;
		display: table;
		margin-bottom: 16px;
		padding-top: 6px;
		&__tax,
		&__total {
			display: table-row;
			span {
				display: table-cell;
				text-align: right;
				// font-size: 16px;
				&:last-child {
					padding-left: 19px;
					font-size: 24px;
					font-weight: bold;
					color: #fff;
				}
			}
		}
		&__tax {
			span {
				padding-bottom: 16px;
			}
		}
	}
	&__message {
		border-top: 2px solid rgba(#fff, 50%);
		text-align: left;
		padding-top: 16px;
		&__support {
			margin-bottom: 3px;
			a {
				text-transform: capitalize;
			}
		}
		p {
			line-height: 1.3;
		}
		a {
			color: inherit;
			text-decoration: underline;
			text-underline-position: under;
			&:hover {
				color: #fff;
			}
		}
	}
}

.attention {
	color: rgba(#fff, 0.8);
	font-size: 14px;
	font-family: Arial;
	font-weight: 700;
}

.highlight {
	color: rgba(230, 63, 87, 1);
	font-family: Arial;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.license-text {
	color: rgba(#fff, 0.5);
	margin: 10px 0;
	font-family: Arial;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	margin: 10px 0;
	.license-text + .license-text {
		margin: 0;
	}
}

@media (min-width: 1024px) {
	.summary {
		min-height: 385px;
	}
}

@media (max-width: 599px) {
	.summary {
		padding: 8px 10px;
		&__title {
			padding-bottom: 11px;
		}
		&__purchase {
			font-size: 14px;
			margin-bottom: 3px;
		}
		&__price {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 18px;
			padding-top: 14px;
			&__tax,
			&__total {
				display: flex;
				flex-wrap: wrap;
				flex: 0 0 100%;
				max-width: 100%;
				justify-content: space-between;
				align-items: flex-end;
				span {
					display: block;
					padding-right: 20px;
					padding-bottom: 0px;
					&:last-child {
						font-size: 14px;
						padding: 0px;
					}
				}
			}
			&__tax {
				padding-bottom: 16px;
			}
		}
		&__message {
			padding-bottom: 5px;
		}
	}
}
</style>
